module.exports = __webpack_public_path__ + "img/rg-vessel-caution.cf0961c3.svg";